import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import { getInboxAccessUrl } from '../../urls/inbox-urls';
import AssigneeOptionContainer from './AssigneeOptionContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssignToUserHeaderHD = ({
  isUngatedForHelpDeskRoutingScopeFiltering,
  workspaceId
}) => /*#__PURE__*/_jsx(AssigneeOptionContainer, {
  children: /*#__PURE__*/_jsxs(UIFlex, {
    className: "p-left-1 p-right-2",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      className: "m-right-1",
      message: "routing-ui.reassignment.assignAnotherUser"
    }), !isUngatedForHelpDeskRoutingScopeFiltering && workspaceId && /*#__PURE__*/_jsx(UIHelpIcon, {
      title: /*#__PURE__*/_jsx("p", {
        className: "m-y-0",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "routing-ui.reassignment.usersSectionHelp.link_jsx",
          elements: {
            UILink
          },
          options: {
            external: true,
            href: getInboxAccessUrl(workspaceId)
          }
        })
      })
    })]
  })
});
AssignToUserHeaderHD.displayName = 'AssignToUserHeaderHD';
export default AssignToUserHeaderHD;